import moment from 'moment';

export default (period: moment.DurationInputArg1, unit: moment.DurationInputArg2) =>
  moment().local().subtract(period, unit);
